import { useMutation } from '@tanstack/react-query';
import { createMessage, CreateMessageParams } from '../../services/backendService';

export const useCreateMessage = () => {
  return useMutation({
    mutationKey: ['createMessage'],
    mutationFn: (params: CreateMessageParams) => createMessage(params),
  });
};
